// component
import {
  EmojiPickerPopoverProps,
  showEmojiPickerPopoverAction,
} from './emoji-picker'

export const showEmojiPickerPopover = (props: EmojiPickerPopoverProps) =>
  showEmojiPickerPopoverAction.invoke(props)
